import { ProductSpecificService } from '@feature/product/services/product-specific.service';
import { MojoWellKnownNames } from '@common/constants/mojo-well-known-names';
import { Injectable } from "@angular/core";

@Injectable()
export class MciProductService implements ProductSpecificService {
  product = MojoWellKnownNames.Products.Mci;
  adminDashboardRoute = '/admin';
}
